/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BrowseInputs */

const th_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียกดู`)
};

const en_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse`)
};

const ja_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見る`)
};

const zh_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现`)
};

const es_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const pt_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const id_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi`)
};

const fr_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer`)
};

const tl_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuklasin`)
};

const vi_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá`)
};

const ko_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`둘러보기`)
};

const de_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken`)
};

const ru_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const tr_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keşfet`)
};

const it_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora`)
};

const pl_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkrywaj`)
};

const uk_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Огляд`)
};

const hi_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोजें`)
};

const ar_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشاف`)
};

const ms_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajah`)
};

const bn_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্বেষণ`)
};

const zh_tw2_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

const zh_hk2_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

const ur_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دریافت`)
};

const fa_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کاوش`)
};

const sw_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gundua`)
};

const nl_browse = /** @type {(inputs: BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdekken`)
};

/**
* | output |
* | --- |
* | "Browse" |
*
* @param {BrowseInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const browse = /** @type {((inputs?: BrowseInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BrowseInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_browse(inputs)
	if (locale === "ja") return ja_browse(inputs)
	if (locale === "zh") return zh_browse(inputs)
	if (locale === "es") return es_browse(inputs)
	if (locale === "pt") return pt_browse(inputs)
	if (locale === "id") return id_browse(inputs)
	if (locale === "fr") return fr_browse(inputs)
	if (locale === "tl") return tl_browse(inputs)
	if (locale === "vi") return vi_browse(inputs)
	if (locale === "ko") return ko_browse(inputs)
	if (locale === "de") return de_browse(inputs)
	if (locale === "ru") return ru_browse(inputs)
	if (locale === "tr") return tr_browse(inputs)
	if (locale === "it") return it_browse(inputs)
	if (locale === "pl") return pl_browse(inputs)
	if (locale === "uk") return uk_browse(inputs)
	if (locale === "hi") return hi_browse(inputs)
	if (locale === "ar") return ar_browse(inputs)
	if (locale === "ms") return ms_browse(inputs)
	if (locale === "bn") return bn_browse(inputs)
	if (locale === "zh-TW") return zh_tw2_browse(inputs)
	if (locale === "zh-HK") return zh_hk2_browse(inputs)
	if (locale === "ur") return ur_browse(inputs)
	if (locale === "fa") return fa_browse(inputs)
	if (locale === "sw") return sw_browse(inputs)
	if (locale === "nl") return nl_browse(inputs)
	return en_browse(inputs)
});